import { Text, Grid, GridItem, Image, Box, } from "@chakra-ui/react";
import ReceptionIcon from "../../../../../assets/images/ReceptionIcon.svg"
import MyDiv from "./departmentList.style";
import { useEffect, useState } from "react";
import { CustomToast } from "../../../../../components";
import { useFetch } from "../../../../../hooks/useFetch";
import { IDepartment } from "./model";
import { useNavigate } from "react-router";
import * as routesNames from '../../../../../constants/routes';
import MemberIcon from '../../../../../assets/images/MemberIcon.svg'
const DepartementList = () => {
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [deptList, setDeptList] = useState<IDepartment[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    loadDepartment();
  }, []);

  async function loadDepartment() {
    const result = await fetchApi<IDepartment[]>('Hrlense_Department/DeptEmployeeCount', 'GET', null, null, '');
    if (result) {
      setDeptList(result);
    }
  }

  const employeeAsPerDepartment = (department: IDepartment) => {
    navigate(routesNames.EMPLOYEES, { state: { department: department, showDepartment: false } });
  }

  return (
    <MyDiv>
      <Grid templateColumns="repeat(5,1fr)" gap={4}>
        {deptList.map((dept, index) => (
          <GridItem key={index} >
            <Box className="card-wrapper" onClick={() => employeeAsPerDepartment(dept)}>
              <Box position="absolute" top="2" right="2" display="flex" alignItems="center" className="common_bg" px={2} py={1} borderRadius="30px" fontSize="sm" fontWeight="medium">
                <Image src={MemberIcon} alt="Members" boxSize={5} mr="1" />
                <Text>{dept.employeeCount}</Text>
              </Box>
              <Box className="flex_column"   >
                <Image src={ReceptionIcon} alt={dept.departmentName} />
                <Text mt={2} className="font-poppins text_medium text_md" >{dept.departmentName}</Text>
              </Box>
            </Box>
          </GridItem>
        ))}
      </Grid>
    </MyDiv>
  );
};

export default DepartementList;
